export default __webpack_public_path__ + "static/media/justine2.2ad38f41.jpg";